.sedlex-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--p-radius-sm);
  padding: var(--p-space-4);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.sedlex-card--raised {
  background: var(--bg-surface-raised);
  box-shadow: var(--shadow-sm);
}

.sedlex-card--interactive {
  cursor: pointer;
}

.sedlex-card--interactive:hover {
  border-color: var(--accent);
  box-shadow: var(--shadow-md);
  background: var(--bg-surface-raised);
}
